@let showsSelected = challenge().isSelected || previewSelected();

<div
  class="card"
  [id]="challenge().offerId"
  [style]="{
    border: config().cardStyles.border,
    boxShadow: withShadow() ? config().cardStyles.boxShadow : 'none',
  }"
>
  <div
    class="card-header"
    role="img"
    [attr.aria-label]="config().header.backgroundImage.bannerAriaLabel"
    [style]="{
      backgroundImage: config().header.backgroundImage.url | transformUrl,
    }"
  ></div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <div
        class="label"
        [style]="{
          color: labelConfig.color,
          fontFamily: labelConfig.fontFamily,
        }"
      >
        {{ labelConfig.label }}
      </div>
    }
  </div>

  <div class="card-content" data-cy="frequency-card-content">
    @if (challenge().progress < challenge().target) {
      <div
        class="card-body"
        data-cy="frequency-card-content"
        [class.opacity-option]="!showsSelected"
      >
        <div
          class="first-label"
          [style]="{
            color: config().body.firstLabel.color,
            fontFamily: config().body.firstLabel.fontFamily,
          }"
          [innerHTML]="
            config().body.firstLabel.text
              | replaceVars: challenge().target
              | safe
          "
        ></div>

        <div
          class="second-label"
          [style]="{
            color: config().body.secondLabel.color,
            fontFamily: config().body.secondLabel.fontFamily,
          }"
          [innerHTML]="
            config().body.secondLabel.text
              | replaceVars: challenge().minAmountByTransaction
              | safe
          "
        ></div>

        <div class="visits-summary">
          <div class="visits-container">
            <span class="number" data-cy="progress">{{
              challenge().progress
            }}</span>
            <span class="sign">/</span>
            <span
              class="number total"
              data-cy="target"
              [style]="{
                backgroundColor: config().body.totalBg,
              }"
              >{{ challenge().target }}</span
            >
          </div>
          <div class="wording" [style.color]="config().body.summary.color">
            <div class="win-text">{{ config().body.summary.text }}</div>
            <div class="target">{{ challenge().rewardRatio }}€</div>
          </div>
        </div>

        <div class="goal">
          @let footerIcon = config().footer.footerIcon;
          @if (footerIcon) {
            <div class="icon">
              <b2c-icon
                [disabled]="true"
                [icon]="footerIcon.imageUrl"
                [buttonTitle]="footerIcon.alternativeText"
              />
            </div>
          }
          <div
            class="remaining-orders"
            [innerHTML]="
              config().footer.label
                | replaceVars: challenge().target - challenge().progress
                | replaceVars: challenge().rewardRatio
                | safe
            "
          ></div>
        </div>
      </div>
    }

    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }
    <!-- Selection Button -->
    @if (!showsSelected) {
      <div class="selection-section">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }

    @if (challenge().canBeUnselected(phase())) {
      <div class="unselect-footer">
        <b2c-unselection-button
          [phase]="phase()"
          [challenge]="challenge()"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
